import React, { useId, useState } from 'react';
import SavedFilterName from './SavedFilterName';
import FilterNotifications from './FilterNotifications';

export default function SavedFilterHeader({ filter, subscription, onChanged }) {
  const [status, setStatus] = useState('');
  const statusId = useId();
  return <>
    {status && <p className="notification-error saved-filter-notification-error" id={statusId} role="alert">{status}</p>}
    <div className="saved-filter-header">
      <SavedFilterName name={filter.name} />
      <FilterNotifications filter={filter} subscription={subscription} onChanged={onChanged}
        onStatusChange={setStatus} statusId={statusId} />
    </div>
  </>;
}
